import React from 'react';
import styled from 'styled-components';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useLocation } from 'react-router-dom';

const Slider = ({ plumbingSlides, roofingSlides, bathroomsSlides, framingSlides, poolsSlides }) => {
  const { pathname } = useLocation();

  let slides;
  if (pathname === '/plumbing') slides = plumbingSlides;
  else if (pathname === '/roofing') slides = roofingSlides;
  else if (pathname === '/bathrooms') slides = bathroomsSlides;
  else if (pathname === '/framing') slides = framingSlides;
  else if (pathname === '/pools') slides = poolsSlides;

  if (!slides || slides.length === 0) return null;

  return (
    <SliderSection>
      <SliderInner>
        <SectionLabel>Project Gallery</SectionLabel>
        <SwiperStyled
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 24 },
          }}
        >
          {slides.map((item) => (
            <SwiperSlide key={item.id}>
              <SlideImage src={item.img} alt={item.alt} loading="lazy" />
            </SwiperSlide>
          ))}
        </SwiperStyled>
      </SliderInner>
    </SliderSection>
  );
};

const SliderSection = styled.section`
  background: #fff;
  padding: 64px 32px 80px;
  @media (max-width: 768px) {
    padding: 48px 20px 64px;
  }
`;

const SliderInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const SectionLabel = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #c89432;
  text-align: center;
  margin-bottom: 32px;
`;

const SwiperStyled = styled(Swiper)`
  width: 100%;

  .swiper-button-prev,
  .swiper-button-next {
    width: 44px;
    height: 44px;
    background: #111827;
    border-radius: 50%;
    color: #fff;
    transition: background 0.25s ease;
    &::after {
      font-size: 14px;
      font-weight: 700;
    }
    &:hover {
      background: #c89432;
    }
  }

  .swiper-pagination-bullet {
    background: #d1d5db;
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: #c89432;
  }

  .swiper-slide {
    height: auto;
  }
`;

const SlideImage = styled.img`
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  display: block;
  border-radius: 6px;
  transition: transform 0.4s ease;
  &:hover {
    transform: scale(1.02);
  }
`;

export default Slider;
